import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Modal, Table, Card, Form, Col, Row , InputGroup} from 'react-bootstrap';
import { BASE_URL } from "../../constants";
import Layout from '../../components/Layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp, faSortUp, faSortDown, faUsers, faArrowDown,
  faMoneyBill, faCity, faExclamationTriangle, faUserCheck, faUserAlt, faSearch
} from "@fortawesome/free-solid-svg-icons";

const AllShelterLosses = () => {
  const [shelterLosses, setShelterLosses] = useState([]);
  const [filteredShelterLosses, setFilteredShelterLosses] = useState([]);
  const [totalShelters, setTotalShelters] = useState(0);
  const [totalLossThisMonth, setTotalLossThisMonth] = useState(0);
  const [daysPassed, setDaysPassed] = useState(0);
  const [selectedShelter, setSelectedShelter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  // Fetch Shelter Losses
  const fetchShelterLosses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/shelters/shelter-losses`);
      const data = response.data.shelterLosses || [];
      
      const updated = data.map((shelter, index) => {
  let stateLossAfterAssignment = 0;
  let AmountToBePaid = 0;

  if (shelter.impactType === "Loss (€)") {
    stateLossAfterAssignment = shelter.stateLossMonthToDate;
  } else if (shelter.impactType === "Overflow Payment (€)") {
    AmountToBePaid = shelter.stateLossMonthToDate;
  }

  return {
    ...shelter,
    id: index + 1,
    stateLossAfterAssignment,
    AmountToBePaid
  };
});


      // Calculate totals
     const totalLoss = updated.reduce((acc, s) => {
  return s.impactType === "Loss (€)" ? acc + (s.stateLossMonthToDate || 0) : acc;
}, 0);

      const days = updated.length > 0 ? updated[0].daysPassed : 0;

      setShelterLosses(updated);
      setFilteredShelterLosses(updated);
      setTotalLossThisMonth(totalLoss);
      setDaysPassed(days);
      setTotalShelters(updated.length);
    } catch (error) {
      console.error("Error fetching shelter losses:", error);
    }
  };

  useEffect(() => {
    fetchShelterLosses();
  }, []);

  const handleModalOpen = (shelter) => {
    setSelectedShelter(shelter);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setSelectedShelter(null);
    setShowModal(false);
  };

  useEffect(() => {
    const filtered = shelterLosses.filter((shelter) =>
      shelter.shelterName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredShelterLosses(filtered);
  }, [searchQuery, shelterLosses]);

  const toggleSort = () => {
    const nextDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    const sorted = [...filteredShelterLosses].sort((a, b) => {
      const lossA = a.stateLossMonthToDate ?? 0;
      const lossB = b.stateLossMonthToDate ?? 0;
      return nextDirection === 'asc' ? lossA - lossB : lossB - lossA;
    });
    setFilteredShelterLosses(sorted);
    setSortDirection(nextDirection);
  };

  return (
    <Layout>
      <div>
        <h2 className="text-center text-primary mb-4">Shelter Losses Overview</h2>
        <div className="d-flex justify-content-between align-items-center mb-3">
    <InputGroup className="w-50">
      <InputGroup.Text>
        <FontAwesomeIcon icon={faSearch} />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </InputGroup>

          <Button variant="outline-cyan" size="sm" onClick={toggleSort}>
            <FontAwesomeIcon icon={sortDirection === 'asc' ? faSortDown : faSortUp} className="me-2" />
            {sortDirection === 'asc' ? 'Sort Loss Desc' : 'Sort Loss Asc'}
          </Button>
        </div>

        {/* Shelter Loss Table */}
        <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
              <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0">#</th>
                  <th className="border-0">Shelter Name</th>
                  <th className="border-0">Occupants</th>
                  <th className="border-0">State Coverage</th>
                  <th className="border-0">State Loss (€)</th>
                  <th className="border-0">Overflow Payment (€)</th>
                  <th className="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredShelterLosses.map((shelter, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{shelter.shelterName}</td>
                    <td>{shelter.currentOccupants}</td>
                    <td>{shelter.stateCoverage}</td>
                         
                    <td>
  {shelter.stateLossAfterAssignment !== 0 && (
    <FontAwesomeIcon icon={faArrowDown} className="text-danger me-1" />
  )}
  {shelter.stateLossAfterAssignment !== undefined && shelter.stateLossAfterAssignment !== null
    ? shelter.stateLossAfterAssignment.toFixed(2)
    : ''}
</td>

<td>
  {shelter.AmountToBePaid !== 0 && (
    <FontAwesomeIcon icon={faArrowUp} className="text-success me-1" />
  )}
  {shelter.AmountToBePaid !== undefined && shelter.AmountToBePaid !== null
    ? Math.abs(shelter.AmountToBePaid).toFixed(2)
    : ''}
</td>



               <td>
                  <Button variant="light" size="sm"  className="responsive-btn" onClick={() => handleModalOpen(shelter)}>
                   See Details →
                  </Button>
</td>
</tr>
))}

</tbody>
</Table>


     
{/* Shelter Details Modal */}
{selectedShelter && (
  <Modal show={showModal} onHide={handleModalClose} centered size="lg" contentClassName="rounded-5 shadow-xl p-3" >
  <Modal.Header closeButton className="border-0 pb-0">
    <Modal.Title className="fw-bold text-gradient-primary fs-3" style={{ letterSpacing: '0.1em' }}>
      {selectedShelter.shelterName} - Details
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
 <Row className="g-4">
  {[
    {
      icon: faUsers,
      label: "Capacity",
      value: selectedShelter.capacity,
      gradient: "linear-gradient(135deg, #3a4d63 0%, #5b7c99 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(58,77,99,0.3)",
    },
    {
      icon: faUserAlt,
      label: "State Covered Users",
      value: selectedShelter.stateCoveredRefugees ?? "N/A",
      gradient: "linear-gradient(135deg, #426e86 0%, #678ba7 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(66,110,134,0.3)",
    },
    {
      icon: faUserCheck,
      label: "Current Occupants",
      value: selectedShelter.currentOccupants,
      gradient: "linear-gradient(135deg, #2b4c7e 0%, #4568a0 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(43,76,126,0.4)",
    },
    {
      icon: faCity,
      label: "State Coverage",
      value: selectedShelter.stateCoverage,
      gradient: "linear-gradient(135deg, #4a5568 0%, #718096 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(74,85,104,0.3)",
    },
    {
      icon: faMoneyBill,
      label: "Cost Per Occupant",
      value:
        typeof selectedShelter.costPerOccupant === "number"
          ? `$${selectedShelter.costPerOccupant.toFixed(2)}`
          : "N/A",
      gradient: "linear-gradient(135deg, #7b8a8b 0%, #95a5a6 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(123,138,139,0.3)",
    },
    {
      icon: faExclamationTriangle,
      label: "State Loss",
      value:
        typeof selectedShelter.stateLossMonthToDate === "number" && selectedShelter.stateLossMonthToDate > 0
  ? `$${selectedShelter.stateLossMonthToDate.toFixed(2)}`
  : "0",
      gradient: "linear-gradient(135deg, #8e5750 0%, #b46a60 100%)",
      iconColor: "white",
      shadow: "0 4px 15px rgba(142,87,80,0.3)",
    },
  ].map(({ icon, label, value, gradient, iconColor, shadow }, idx) => (
    <Col md={6} key={idx}>
      <div
        className="d-flex align-items-center p-4 rounded-4 text-white"
        style={{
          background: gradient,
          boxShadow: shadow,
          cursor: "default",
          transition: "transform 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        <div
          className="d-flex justify-content-center align-items-center rounded-circle me-4"
          style={{
            width: 60,
            height: 60,
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            boxShadow: "0 0 8px rgba(255,255,255,0.3)",
            color: iconColor,
            fontSize: "1.8rem",
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <div>
          <div
            className="fw-light text-uppercase mb-1"
            style={{ letterSpacing: "0.15em", fontSize: "0.75rem", opacity: 0.85 }}
          >
            {label}
          </div>
          <div
            className="fw-bold"
            style={{ fontSize: "1.6rem", lineHeight: 1 }}
          >
            {value}
          </div>
        </div>
      </div>
    </Col>
  ))}
</Row>
  </Modal.Body>
</Modal>


)}
</Card.Body>
</Card>
<Row className="mb-4 text-center">
  {[totalShelters, totalLossThisMonth, daysPassed].map((value, idx) => {
    const titles = ["Total Shelters", "Total Monthly Loss", "Days Tracked"];
    const isLoss = idx === 1;
    return (
      <Col md={4} key={idx}>
        <Card
          className="shadow-sm border-0 rounded-4 bg-white"
          style={{ minHeight: "120px" }}
        >
          <Card.Body className="d-flex flex-column justify-content-center align-items-center">
            <h6 className="text-muted mb-2" style={{ letterSpacing: '0.05em', fontWeight: 500 }}>
              {titles[idx]}
            </h6>
            <h5
              className={`mb-0 ${isLoss ? "text-danger" : "text-primary"}`}
              style={{ fontWeight: '700', fontSize: '1.8rem', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
            >
              {isLoss ? `€${value.toFixed(2)}` : value}
            </h5>
          </Card.Body>
        </Card>
      </Col>
    );
  })}
</Row>



</div>
</Layout>

  );
};

export default AllShelterLosses;
